<!--
  工单视图 通用工单列表页
-->
<template>
  <div class="ticket-view-main">
    <UserGuide />

    <div class="content-left border-left-3" >
      <ul role="menubar" class="el-menu">
        <template v-for="(item, key) in ticketViewList">
          <li :key="item.id"
            role="menuitem"
            :class="{'el-menu-item': true, 'is-active': item.id == viewId}"
            @click="changeNav(item.id, key, $event)">
            <span :title="'#' + item.id + ' '+ item.name + '(' + item.description+')'"
              style="width:70%;">{{item.name}}</span>
            <ViewTicketCount style="width:30%;" :value="item"/>
          </li>
        </template>
      </ul>

      <el-menu v-permission="'TICKET_MORE_VIEW_AUTH'" ref="moreView" @close="onMenuClose" @open="onMenuOpen">
        <el-submenu index="1" :title="moreTicketViewDescriptionTitle">
          <template slot="title">
            <span style="color:#D0D0D0;">更多视图</span>
          </template>

          <el-menu-item v-for="each in otherTicketViewList"
            :key="each.id"
            :index="'1-' + each.id" >
            <template>
              <span :data-id="each.id"
                @click="changeNav(each.id, null, $event)"
                :title="'#' + each.id + ' '+ each.name + '(' + each.description+')'"
                style="width:65%;">{{each.name}}</span>
              <ViewTicketCount style="width:30%;" :value="each"/>
            </template>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <div class="content-right">
      <ViewTicketList ref="ticketList"/>

      <NewTicketDialog ref="newTicketDialog"/>
    </div>

    <el-backtop target=".content-right" :bottom="140"/>
  </div>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil'

var _moreTicketViewDescriptionTitle = "工单视图的本质是存储下来的一些搜索条件的组合, 可以筛选出符合条件的工单\n如需有需要, 可以联系管理员修改或添加";

export default {
  name: 'TicketViewMain',

  data () {
    return {
      moreTicketViewDescriptionTitle : _moreTicketViewDescriptionTitle,
      loginUserInfo: {}, // 当前用户
      viewId: '', // 视图id
      ticketViewList: [], // 视图列表
      otherTicketViewList : [], //
      uploaderDomain: null
    }
  },

  mounted() {
    var _this = this;

    _this.getMyTicketView();

    // 指定了视图id
    if( !!this.$route.query.ticketType && !!this.$route.query.viewId ) {
      setTimeout(() => {
        this.changeNav(this.$route.query.viewId);
      }, 900); // 后 @see 91
    }

    _this.viewId = localStorage.getItem(CacheUtil.TicketViewId);

    var otherMenuOpen = localStorage.getItem(CacheUtil.TicketOtherMenuOpen) || "false";
    if ( "true" == otherMenuOpen ) {
      _this.$refs.moreView.open(1);

      // 高亮
      setTimeout(()=>{
        var span = $("span[data-id='" + _this.viewId + "']");
        span.parent().addClass("is-active");
      }, 800); // 先 @see 78
    }

    // 刷新视图列表的事件通知
    window.addEventListener('event_load_ticket_view', function(event) {
      _this.getMyTicketView();
    });
  },

  methods: {
    onMenuClose() {
      localStorage.setItem(CacheUtil.TicketOtherMenuOpen, "false");
    },

    onMenuOpen() {
      localStorage.setItem(CacheUtil.TicketOtherMenuOpen, "true");

      this.getOtherTicketView(); // 拉数据
    },

    // 查询视图列表
    getMyTicketView() {
      var _this = this;

      sdk.TicketViewApi().listMyViewCached().then((res) => {
        _this.ticketViewList = res;

        if(_this.viewId == '') {
          _this.viewId = _this.ticketViewList[0].id;
        } else {
          _this.viewId = localStorage.getItem(CacheUtil.TicketViewId);
        }
      });
    },

    // 查询视图列表
    getOtherTicketView() {
      var _this = this;

      sdk.TicketViewApi().listMoreMyViewCached({
        page: { pageSize: 999, orderBy: "`index` ASC" }
      }).then(res => {
        _this.otherTicketViewList = res;
      });
    },

    // 左侧菜单点击事件
    changeNav(id) {
      $('.el-menu').find('li').removeClass('is-active'); // 移除当前样式

      $("span[data-id=" + id + "]").closest('.el-menu-item').addClass('is-active'); // 当前点击菜单添加样式

      this.viewId = id;

      localStorage.setItem(CacheUtil.TicketViewId, this.viewId);
      this.$refs.ticketList.queryTicketList_2(1);
    },

    //获取文件后缀名
    getSuffix(file) {
      var lastPlace = file.lastIndexOf("."), fileLength = file.length;
      return file.substring(lastPlace + 1, fileLength);
    }
  }
}
</script>

<style>
.el-table td, .el-table th {
  padding: 8px 0;
}

.el-dialog__footer {
  padding : 0 20px 20px 0;
}

.el-dialog__title{
  line-height: 50px;
  padding-left: 20px;
}

.el-tabs__nav-wrap::after {
  height : 0;
}

.van-radio-group {
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ticket/TicketViewMain.vue